<div class="dictionary-meta">
  <div class="row">
    <app-text [formGroup]="$safeNavigationMigration(model()?.meta.formGroup)" [model]="$safeNavigationMigration(model()?.type?.data?.keyPattern)" [meta]="keyPattern"></app-text>
  </div>
  <div class="row">
    <app-number [formGroup]="$safeNavigationMigration(model()?.meta.formGroup)" [model]="$safeNavigationMigration(model()?.type?.data?.keyMaxLength)" [meta]="keyMaxLength"></app-number>
  </div>
  <div class="row">
    <app-text [formGroup]="$safeNavigationMigration(model()?.meta.formGroup)" [model]="$safeNavigationMigration(model()?.type?.data?.valuePattern)" [meta]="valuePattern"></app-text>
  </div>
  <div class="row">
    <app-number [formGroup]="$safeNavigationMigration(model()?.meta.formGroup)" [model]="$safeNavigationMigration(model()?.type?.data?.valueMaxLength)" [meta]="valueMaxLength"></app-number>
  </div>
</div>
